import Handsontable from 'handsontable';

export function deselectCells(ht: Handsontable) {
  if (ht.getSelected()) {
    ht.deselectCell();
  }
}
